var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file PortalPopup
 * @author (wangzichuan)
 */

import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

/* global window */

/**
 * 参数说明
 * children 子node
 * className 类名
 */

var PortalPopup = function (_Component) {
    _inherits(PortalPopup, _Component);

    function PortalPopup(props) {
        _classCallCheck(this, PortalPopup);

        var _this = _possibleConstructorReturn(this, (PortalPopup.__proto__ || Object.getPrototypeOf(PortalPopup)).call(this, props));

        var doc = window.document;
        _this.node = doc.createElement('div');
        doc.body.appendChild(_this.node);
        return _this;
    }

    _createClass(PortalPopup, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.document.body.removeChild(this.node);
        }
    }, {
        key: 'render',
        value: function render() {
            return createPortal(React.createElement(
                'div',
                { className: this.props.className },
                this.props.children
            ), // 塞进传送门的JSX
            this.node // 传送门的另一端DOM node
            );
        }
    }]);

    return PortalPopup;
}(Component);

PortalPopup.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};
PortalPopup.defaultProps = {};
export default PortalPopup;